import { IConsumptionsFilters } from '../../../models/Filters/ConsumptionsFilters';
import { ExportAllProtocolConsumptionByProtocol } from '../../../services/ProtocolConsumptions.Service';

export const ExportProtocolConsumptionWrapper = async (authToken: string, filters: IConsumptionsFilters, protocolId: string): Promise<Blob> => {
    return await ExportAllProtocolConsumptionByProtocol(
        filters,
        authToken,
        protocolId
    );
};